// import useQueryFeature from "./useQueryFeature";

const useJarvisDomainLogic = () => {
  // const featureResp = useQueryFeature('domainwithctb');
  // return featureResp;
  return [true, {}];
};

export default useJarvisDomainLogic;
